import React from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import {
  selectSubmissionCardSubheaderAsCPE,
  selectSubmissionCardSubheaderAsEngagementPercent,
  selectSubmissionCardSubheaderAsEstimatedCPE,
} from '@store/submissions'
import SubHeaderLabelCPE from './Label/CPE'
import SubHeaderLabelEngagementPercent from './Label/EngagementPercent'
import SubHeaderLabelEstimatedCPE from './Label/EstimatedCPE'
import SubHeaderLabelFollowers from './Label/Followers'

interface ISubmissionCardHeaderProps {
  campaignId: number
  submissionId: number
}

const SubmissionCardSubHeader: React.FC<ISubmissionCardHeaderProps> = ({
  campaignId,
  submissionId,
}) => {
  const { showAsCPE, showAsEstimatedCPE, showAsEngagementPercent } = useSelector(
    (state: IApplicationState) => ({
      showAsCPE: selectSubmissionCardSubheaderAsCPE(state),
      showAsEstimatedCPE: selectSubmissionCardSubheaderAsEstimatedCPE(state),
      showAsEngagementPercent: selectSubmissionCardSubheaderAsEngagementPercent(state),
    }),
    shallowEqual,
  )

  if (showAsEngagementPercent) {
    return <SubHeaderLabelEngagementPercent submissionId={submissionId} />
  }

  if (showAsEstimatedCPE) {
    return <SubHeaderLabelEstimatedCPE submissionId={submissionId} />
  }

  if (showAsCPE) {
    return <SubHeaderLabelCPE submissionId={submissionId} />
  }

  return <SubHeaderLabelFollowers campaignId={campaignId} submissionId={submissionId} />
}

export { SubmissionCardSubHeader }
export default SubmissionCardSubHeader
